import { Svg, Path } from 'react-native-svg'

interface CoinProps {
  width?: number
  height?: number
  color?: string
}

export function CoinIcon({ width = 32, height = 32, color = 'white' }: CoinProps) {
  return (
    <Svg width={width} height={height} viewBox="0 0 32 32" fill="none">
      <Path
        d="M18.0002 12.6668H15.0002C14.0797 12.6668 13.3335 13.413 13.3335 14.3335C13.3335 15.254 14.0797 16.0002 15.0002 16.0002H17.0002C17.9206 16.0002 18.6668 16.7464 18.6668 17.6668C18.6668 18.5873 17.9206 19.3335 17.0002 19.3335H14.0002M16.0002 11.3335V12.0002M16.0002 20.0002V20.6668M26.6668 16.0002C26.6668 21.8912 21.8912 26.6668 16.0002 26.6668C10.1091 26.6668 5.3335 21.8912 5.3335 16.0002C5.3335 10.1091 10.1091 5.3335 16.0002 5.3335C21.8912 5.3335 26.6668 10.1091 26.6668 16.0002Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
      />
    </Svg>
  )
}
